import * as React from "react";

/**
 * useIsDark
 * Tracks whether the document is currently in dark mode by observing the
 * documentElement class list. Updates if the "dark" class is toggled.
 */
export default function useIsDark(): boolean {
  const [isDark, setIsDark] = React.useState<boolean>(() =>
    typeof document !== "undefined"
      ? document.documentElement.classList.contains("dark")
      : false
  );

  React.useEffect(() => {
    if (typeof document === "undefined") return;

    const cb = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    // Observe changes to the "class" attribute on <html>
    const observer = new MutationObserver(cb);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Initial sync (in case classes were changed before mount)
    cb();

    return () => observer.disconnect();
  }, []);

  return isDark;
}
